import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const WishlistContext = createContext(null);

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [items, setItems] = useState([]); // array of product objects

  const refresh = useCallback(async () => {
    if (!user || user === false) {
      setItems([]);
      return;
    }
    try {
      const { data } = await api.get("/wishlist");
      setItems(data.items || []);
    } catch {
      setItems([]);
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const has = (productId) => items.some((p) => p.id === productId);

  const toggle = async (product) => {
    if (!user || user === false) {
      throw new Error("Please sign in to use the wishlist");
    }
    if (has(product.id)) {
      await api.delete(`/wishlist/${product.id}`);
      setItems((prev) => prev.filter((p) => p.id !== product.id));
    } else {
      await api.post("/wishlist", { product_id: product.id });
      setItems((prev) => [...prev, product]);
    }
  };

  return (
    <WishlistContext.Provider value={{ items, has, toggle, count: items.length, refresh }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
